export default [
    {
        path: "/admin/nationalities",
        name: "nationality",
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/nationality")
    }
];
